import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLD from '@/components/base/JsonLD';
import ToolsHub from './components/ToolsHub';
import Breadcrumb from '@/components/base/Breadcrumb';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Narzędzia finansowe — kalkulatory kredytowe | EXPERT KREDYTOWY',
  description:
    'Darmowe kalkulatory kredytowe: porównanie banków, nadpłata kredytu, refinansowanie i zdolność kredytowa. Policz samodzielnie przed rozmową z bankiem. Bezpłatna konsultacja z doradcą w Sanoku.',
  url: 'https://kredytpodkarpacie.pl/narzedzia',
  isPartOf: {
    '@type': 'WebSite',
    name: 'EXPERT KREDYTOWY',
    url: 'https://kredytpodkarpacie.pl',
  },
};

export default function NarzedziaPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLD data={schema} />
      <Navbar />
      <div className="pt-16 md:pt-20">
        <div className="px-4 md:px-8 lg:px-12 mb-4">
          <Breadcrumb />
        </div>
        <main>
          <ToolsHub />
        </main>
      </div>
      <Footer />
    </div>
  );
}
